import React from 'react';
import { Formik } from 'formik';
import { defaultValues, createValidationSchema, updateValidationSchema } from './types';
import { AddMerchFormValues } from './types';
import { MerchFormFields } from './components/MerchFormFields';

interface AddMerchFormProps {
  onSubmit: (values: AddMerchFormValues) => void;
  onCancel: () => void;
  isEditMode?: boolean;
  initialValues?: AddMerchFormValues;
  existingImageUrl?: string;
}

export const AddMerchForm: React.FC<AddMerchFormProps> = ({
  onSubmit,
  onCancel,
  isEditMode = false,
  initialValues = defaultValues,
  existingImageUrl,
}) => {
  const handleSubmit = (values: AddMerchFormValues) => {
    onSubmit(values);
  };

  const validationSchema = isEditMode ? updateValidationSchema : createValidationSchema;

  return (
    <div className="merch-form">
      <h2>{isEditMode ? 'Update Merch' : 'Add New Merch'}</h2>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnMount={true}
        validateOnChange={true}
        validateOnBlur={true}
        validateOnSubmit={true}
      >
        <MerchFormFields
          onCancel={onCancel}
          isEditMode={isEditMode}
          existingImageUrl={existingImageUrl}
        />
      </Formik>
    </div>
  );
};
